import React from 'react';
import { Link } from 'react-router-dom';
import "../css/checkout.css";
import { useStateValue } from '../StateProvider';
import CheckoutProduct from './CheckoutProduct';
import Subtotal from './Subtotal';



const Checkout = () => {
    const [{basket, user}, dispatch] = useStateValue();
    return (
        <div className="checkout">
            <div className="checkout__left">
                <img className="checkout__ad" src="https://www.dreamsoft4u.com/images/amazon-service-banner.png" alt="" />
                <div>
                <h4>Hello, {user ? user?.email : "Guest"}</h4>
                <h2 className="checkout__title">
                    Your Shopping Basket
                </h2>
                
                {basket?.map( item => (
                    <CheckoutProduct
                    key={item.id}
                    id={item.id}
                    title={item.title}
                    image={item.image}
                    price={item.price}
                    rating={item.rating}
                    />
                 ))}
                
                 
        
                </div>
                
            </div>
            <div className="checkout__right">
                <Subtotal />
            </div>

        </div>
    )
}

export default Checkout;
